import clsx from 'clsx';
import type { ReactNode } from 'react';
import { MdCheck } from 'react-icons/md';

import type { ReviewItem } from '../eventWizard.types';
import s from '../EventWizardModal.module.scss';

interface StepReviewProps {
  items: ReviewItem[];
  /** What is being created: 'Event' from the event wizard, 'Task' from the task sheet. */
  noun: string;
  /** The tag picker: the AI's tags, which the user keeps, removes or adds to. */
  tags?: ReactNode;
}

export function StepReview({ items, noun, tags }: StepReviewProps) {
  return (
    <>
      <div className={s.reviewIntro}>
        <span className={s.reviewCheckCircle}>
          <MdCheck className={s.reviewCheckCircleIcon} />
        </span>
        <p className={s.reviewLead}>
          Everything&#39;s ready - give it a final look, then create your {noun.toLowerCase()}.
        </p>
      </div>
      <div className={s.reviewChecklist}>
        {items.map((item) => {
          const Row = item.onClick ? 'button' : 'div';
          return (
            <Row
              key={item.label}
              {...(item.onClick ? { type: 'button' as const, onClick: item.onClick } : {})}
              className={clsx(s.reviewCheckRow, item.onClick && s.reviewCheckRowButton)}
            >
              <MdCheck className={s.reviewCheckIcon} aria-hidden />
              <span className={s.reviewCheckLabel}>{item.label}</span>
              <span className={s.reviewCheckValue}>{item.value}</span>
            </Row>
          );
        })}
      </div>
      {tags && (
        <div className={s.reviewTags}>
          <span className={s.reviewTagsLabel}>Tags</span>
          {tags}
        </div>
      )}
    </>
  );
}
